import { useState } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";

type GoogleMapsProviderProps = { children: React.ReactNode };

const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = (props) => {
  const { children } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <APIProvider
      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
      libraries={["places", "routes"]}
      onLoad={() => {
        console.log("Maps API has loaded.");
        setIsLoaded(true);
      }}
    >
      {isLoaded ? children : null}
    </APIProvider>
  );
};

export default GoogleMapsProvider;
